/**
 * RBRouteSelector Component
 * Dropdown selector for RB route types
 */

import React from 'react';
import { RBRouteType } from '../types';
import { getAvailableRBRoutes, getRBRouteDefinition } from '../rules/routeRules';
import './RouteSelector.css';

interface RBRouteSelectorProps {
  selectedRoute: RBRouteType;
  onRouteChange: (route: RBRouteType) => void;
  disabled?: boolean;
  /** DOM id for the <select>. Required for the same reason as RouteSelector's — see that file. */
  id: string;
}

const RBRouteSelector: React.FC<RBRouteSelectorProps> = ({
  selectedRoute,
  onRouteChange,
  disabled = false,
  id,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onRouteChange(event.target.value as RBRouteType);
  };

  return (
    <div className="route-selector">
      <select
        id={id}
        className="route-select route-select-rb"
        value={selectedRoute}
        onChange={handleChange}
        disabled={disabled}
      >
        {/* From the registry, not a hard-coded list, so a route added to rbRouteDefinitions
            appears here without touching this component. Matches the on-field picker, which
            already reads getAvailableRBRoutes(). */}
        {getAvailableRBRoutes().map((route) => {
          const definition = getRBRouteDefinition(route);
          return (
            <option key={route} value={route}>
              {definition?.name ?? route}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default RBRouteSelector;
